// extracted by mini-css-extract-plugin
module.exports = {"custom-urls-header":"custom-url_custom-urls-header__1VpxI","custom-urls-title":"custom-url_custom-urls-title__3bVrY"};